exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".highlight.widget {\n  width: 9px;\n  min-width: 8px;\n  max-width: 8px;\n}\n\n.highlight.widget.selected {\n  background-color: #4343FF;\n}\n\n.highlight.widget.child {\n  background-color: #CCCC00;\n}\n\n.highlight.widget.parent {\n  background-color: #8090FF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/highlight/index.css
// module id = 517
// module chunks = 0